import { useEffect, useRef } from "react";
import { wsUrl } from "../lib/api";

export function useWS(onEvent, enabled = true) {
  const handler = useRef(onEvent);
  handler.current = onEvent;

  useEffect(() => {
    if (!enabled || !localStorage.getItem("cs_token")) return;
    let ws;
    let closed = false;
    const connect = () => {
      ws = new WebSocket(wsUrl());
      ws.onmessage = (e) => {
        try {
          const { event, data } = JSON.parse(e.data);
          handler.current(event, data);
        } catch {}
      };
      ws.onclose = () => {
        if (!closed) setTimeout(connect, 3000);
      };
    };
    connect();
    return () => {
      closed = true;
      if (ws && ws.readyState === WebSocket.OPEN) ws.close();
      else if (ws) ws.onopen = () => ws.close();
    };
  }, [enabled]);
}
